import React from "react";
import { useShallow } from "zustand/react/shallow";
import { Card } from "@uno/protocol";
import useStoreRoomPlayer from "../../../store/useStoreRoomPlayer";
import useStoreRoomScene from "../../../store/useStoreRoomScene";
import useStoreAnimation from "../../../store/useStoreAnimation";
import RevealRoomPlayerCardsAnimation from "../../../animation/RevealRoomPlayerCardsAnimation";
import { useSounds } from "../../../context/SoundContext";

const useRefreshRoomPlayerCard = () => {
    const refreshCardsFromRoomScene = useStoreRoomScene(useShallow(state => state.refresh));
    const enqueueAnimation = useStoreAnimation(useShallow(state => state.enqueue));
    const { play } = useSounds();

    return React.useCallback(({ cards, animate }: { cards: Array<Card>, animate?: boolean }) => {
        const playerId = useStoreRoomPlayer.getState().roomPlayer?.player?.id;

        if(!playerId) {
            throw new Error("Room player not found");
        }

        const previousCards = useStoreRoomScene.getState().cards[playerId] || [];

        refreshCardsFromRoomScene(playerId, cards.map(card => ({ id: card.id, type: card.type, canBePut: card.canBePut, isHoverable: true })));

        if(animate) {
            const backCardIds = new Set(previousCards.filter(card => card.type === "BACK").map(card => card.id));
            const cardsToReveal = cards.filter(card => backCardIds.has(card.id));

            if(cardsToReveal.length > 0) {
                cardsToReveal.forEach(card => {
                    const { initial, effects, transitions, duration, onAnimationEnd } = RevealRoomPlayerCardsAnimation();
                    enqueueAnimation(card.id, { name: "reveal-room-player-card", initial, effects, transitions, duration, onAnimationEnd, isAsynchronous: true });
                });

                play("flipCard");
            }
        }
    }, []);
}

export default useRefreshRoomPlayerCard;
